import { BasicFrame } from 'components/organisms';
import { Button, Countdown } from 'components';
import { frameConfigBasicTink } from '../../AppConfig';
import { ROUTES } from 'utils/constants/constants_routes';
import { SessionSavedIcon } from 'components/icons';
import { useCustomNavigation } from 'hooks/useCustomNavigation';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './TinkLater.module.scss';

export default function TinkLater() {
  const { navigateToOnlineBankVerification } = useCustomNavigation();
  const { t } = useTranslation('tinkLater');
  const navigate = useNavigate();
  return (
    <BasicFrame {...frameConfigBasicTink} backBtnHidden headerLayout="centered">
      <div className={styles.layout} data-test="tinkLater-layout">
        <SessionSavedIcon />
        <div className={styles.title} data-test="tinkLater-title">
          {t('title')}
        </div>
        <div className={styles.content} data-test="tinkLater-content">
          {t('content')}
        </div>
        <hr className={styles['separator']} />
        <div className={styles['timer-title']} data-test="tinkLater-countTitle">
          {t('countTitle')}
        </div>
        <div className={styles['timer-wrapper']} data-test="tinkLater-timer">
          <Countdown date={new Date(Date.now() + 3 * 60 * 60 * 24 * 1000)} />
        </div>
        <Button
          className={styles.cto}
          onClick={() => navigate(ROUTES.FIRST_LOAN_MANUAL_UPLOAD)}
          dataTest="tinkLater-cto"
        >
          {t('cto')}
        </Button>
        <Button
          outlined
          onClick={navigateToOnlineBankVerification}
          dataTest="tinkLater-ctoSecondary"
        >
          {t('ctoSecondary')}
        </Button>
      </div>
    </BasicFrame>
  );
}
